import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as o } from "../_virtual/_tslib.js";
import { jsx as r } from "react/jsx-runtime";
import { Fonts as e } from "@vds-core/typography";
import { calculateRem as n } from "@vds-core/utilities";
import { AccessibilityTokens as t } from "@vds-tokens/accessibility";
import { TypographyTokens as i } from "@vds-tokens/typography";
import s from "styled-components";
var a = n(26),
  d = s.label.withConfig({
    displayName: "CheckboxLabelWrapper",
    componentId: "VDS__sc-on7kvr-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  ", ";\n  ", ";\n\n  color: ", ";\n  -webkit-tap-highlight-color: transparent;\n\n  input[type='checkbox'] {\n    position: absolute;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0;\n    border: 0;\n    white-space: nowrap;\n    z-index: 1;\n    &:hover {\n      cursor: pointer;\n    }\n    ", ";\n  }\n"])), i.lineheight.body[20].value, i.fontsize.body[16].value, e.VerizonNHGeDS, i.letterspacing.wide.value, function (_ref) {
    var o = _ref.errored;
    return o && "\n  margin-bottom: 9px; //8px + 1px additonal border outside aligned\n  ";
  }, function (_ref2) {
    var o = _ref2.disabled;
    return o && "\n    cursor: default;\n  ";
  }, function (_ref3) {
    var o = _ref3.color;
    return o;
  }, function (_ref4) {
    var o = _ref4.$showFocus,
      r = _ref4.color,
      e = _ref4.$focusBorderRadius;
    return o && "\n      &:focus {\n        outline: none;\n        + svg {\n          outline: none;\n        } \n        &:not(:hover):not(:visited):not(:active) + span {\n          &::after {\n            background: transparent;\n            border: ".concat(n(t.focusring.borderwidth.value), " ").concat(t.focusring.borderstyle.value, " ").concat(r, ";\n            box-sizing: border-box;\n            content: '';\n            height: ").concat(a, ";\n            left: 50%;\n            position: absolute;\n            top: 50%;\n            transform: translate(-50%, -50%);\n            width: ").concat(a, ";\n            border-radius: ").concat(e, ";\n          }\n        }\n      }\n      ");
  }),
  l = function l(e) {
    var n = e.focusBorderRadius,
      t = e.showFocus,
      i = e.error,
      s = o(e, ["focusBorderRadius", "showFocus", "error"]);
    return r(d, Object.assign({}, s, {
      $focusBorderRadius: n,
      $showFocus: t,
      $error: i,
      disabled: e.disabled,
      color: e.color
    }));
  };
l.defaultProps = {
  disabled: !1
};
export { l as default };